/** @jsxImportSource @emotion/react */
import { FC, ReactNode } from 'react'
import Typography from '@mui/material/Typography'
import * as classes from './styles'

const COPYRIGHT_MESSAGE = `Copyright ©${new Date().getFullYear()} Booster Prep Inc | All Rights Reserved`

interface ContainerProps {
  children: ReactNode | ReactNode[]
}

const AuthContainer: FC<ContainerProps> = ({ children }) => (
  <div css={classes.container}>
    <div css={classes.topSpace} />
    <div css={classes.wrapper}>{children}</div>
    <div css={classes.bottomSpace}>
      <Typography css={classes.copyright} variant="body3">
        {COPYRIGHT_MESSAGE}
      </Typography>
    </div>
  </div>
)

export default AuthContainer
